import { useEffect, useState } from "react";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Autocomplete, Grid, TextField } from "@mui/material";
import {  toast } from "react-toastify";import styles from "./Orders.module.scss";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import {
  LocalUrlEnum,
  UrlEnum,
  titleForReportsTotal,
} from "../../Utils/Utils";
import { Vocabulary } from "../../Utils/Vocabulary";
import { getData } from "../../Services/getData";

export default function DateFilters(props) {
  const { state } = props;
  const navigate = useNavigate();
  const notifyError = (message) => toast.error(message);
  //   const navigate = useNavigate();

  const [paymentTypeOptions, setPaymentTypeOptions] = useState([]);

  useEffect(() => {
    getData(`${UrlEnum.paymentTypes}/enabled`).then((res) => {
      if (res?.data) setPaymentTypeOptions(res.data);
    });
  }, []);

  // Local, uncontrolled-from-the-server copies of the two dates: typing
  // updates these on every keystroke (so the input stays responsive), but
  // the actual filter/fetch only fires once the user finishes editing —
  // via onAccept (calendar selection, Enter) or onBlur (typed by hand,
  // which onAccept alone does not cover).
  const [localStartDate, setLocalStartDate] = useState(state.startDate);
  const [localEndDate, setLocalEndDate] = useState(state.endDate);

  useEffect(() => {
    setLocalStartDate(state.startDate);
  }, [state.startDate]);

  useEffect(() => {
    setLocalEndDate(state.endDate);
  }, [state.endDate]);

  /**
   *
   * @param name
   * @param value
   */
  const addParamToQueryString = (name, value) => {
    const currentSearch = window.location.search;
    const searchParams = new URLSearchParams(currentSearch);
    searchParams.set(name, value);

    const newQueryString = `?${[...searchParams.entries()]
      .map(([key, val]) => `${key}=${val}`)
      .join("&")}`;

    navigate(`${window.location.pathname}${newQueryString}`);
  };

  /**
   * Commits a finished edit of the start date (called from onAccept and
   * onBlur alike). No-ops if the value isn't a valid date or hasn't
   * actually changed, so calendar selection + the subsequent blur don't
   * both trigger a fetch.
   * @param {*} event
   * @returns
   */
  function commitStartDate(event) {
    if (!moment(event).isValid()) return;
    if (moment(event).isSame(state.startDate, "day")) return;
    let newDate = Object.assign({}, state);
    if (moment(event).isAfter(state.endDate)) {
      notifyError(
        "Data este invalidă! Nu puteți alege data de start după data de stop."
      );
      return;
    }
    newDate.startDate = moment(event);
    if (state.search)
      navigate(
        `${LocalUrlEnum.orders}?page=${newDate.page + 1}?perPage=${
          state.perPage
        }?filter=${newDate.filter}?sort=${newDate.sort.name},${
          newDate.sort.direction
        }?startDate=${moment(newDate.startDate._d).format(
          "YYYY-MM-DD"
        )}?endDate=${moment(newDate.endDate._d).format(
          "YYYY-MM-DD"
        )}?paymentType=${newDate.paymentType}?search=${newDate.search}`
      );
    else
      navigate(
        `${LocalUrlEnum.orders}?page=${newDate.page + 1}?perPage=${
          newDate.perPage
        }?filter=${newDate.filter}?sort=${newDate.sort.name},${
          newDate.sort.direction
        }?startDate=${moment(newDate.startDate._d).format(
          "YYYY-MM-DD"
        )}?endDate=${moment(newDate.endDate._d).format(
          "YYYY-MM-DD"
        )}?paymentType=${newDate.paymentType}`
      );
  }

  /**
   * Commits a finished edit of the end date (called from onAccept and
   * onBlur alike). Same no-op guards as commitStartDate.
   * @param {*} event
   * @returns
   */
  function commitEndDate(event) {
    if (!moment(event).isValid()) return;
    if (moment(event).isSame(state.endDate, "day")) return;
    let newDate = Object.assign({}, state);
    if (moment(event).isAfter(moment())) {
      notifyError(
        "Data este invalidă! Nu puteți alege data de stop după data actuală."
      );
      return;
    }
    if (moment(event).isBefore(state.startDate)) {
      notifyError(
        "Data este invalidă! Nu puteți alege data de stop înaintea datei de start."
      );
      return;
    }
    newDate.endDate = moment(event);
    if (state.search)
      navigate(
        `${LocalUrlEnum.orders}?page=${newDate.page + 1}?perPage=${
          state.perPage
        }?filter=${newDate.filter}?sort=${newDate.sort.name},${
          newDate.sort.direction
        }?startDate=${moment(newDate.startDate._d).format(
          "YYYY-MM-DD"
        )}?endDate=${moment(newDate.endDate._d).format(
          "YYYY-MM-DD"
        )}?paymentType=${newDate.paymentType}?search=${newDate.search}`
      );
    else
      navigate(
        `${LocalUrlEnum.orders}?page=${newDate.page + 1}?perPage=${
          newDate.perPage
        }?filter=${newDate.filter}?sort=${newDate.sort.name},${
          newDate.sort.direction
        }?startDate=${moment(newDate.startDate._d).format(
          "YYYY-MM-DD"
        )}?endDate=${moment(newDate.endDate._d).format(
          "YYYY-MM-DD"
        )}?paymentType=${newDate.paymentType}`
      );
  }

  return (
    <Grid container spacing={3}>
       <Grid item xs={6} md={6} lg={6} style={{ maxWidth: "100%" }}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DesktopDatePicker
            label="Data de start"
            inputFormat="dd-MM-yyyy"
            value={localStartDate}
            className={styles.date}
            onChange={(newValue) => setLocalStartDate(newValue)}
            onAccept={commitStartDate}
            renderInput={(params) => (
              <TextField
                {...params}
                onBlur={(event) => {
                  params.onBlur?.(event);
                  commitStartDate(localStartDate);
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={6} md={6} lg={6}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DesktopDatePicker
            label="Data de stop"
            inputFormat="dd-MM-yyyy"
            value={localEndDate}
            className={styles.date}
            onChange={(newValue) => setLocalEndDate(newValue)}
            onAccept={commitEndDate}
            renderInput={(params) => (
              <TextField
                {...params}
                onBlur={(event) => {
                  params.onBlur?.(event);
                  commitEndDate(localEndDate);
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={6} md={6} lg={6}>
        <Autocomplete
          options={paymentTypeOptions}
          getOptionLabel={(option) =>
            option && option !== "null" && option !== "undefined"
              ? titleForReportsTotal[option]
              : ""
          }
          isOptionEqualToValue={(option, value) => option === value}
          value={state.paymentType}
          freeSolo={false}
          renderInput={(params) => (
            <TextField
              {...params}
              label={Vocabulary.paymentType}
              size="large"
            />
          )}
          onChange={(event, newValue) => {
            addParamToQueryString("paymentType", newValue);
          }}
        />
      </Grid>
    </Grid>
  );
}
